//Player history
//This will go through all the leagues/teams that a player used to play for
//and show all their stats.
import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import Footer from '../../shared/components/UIElements/Footer'
import './Players.css'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import badgersLogo from '../../shared/components/images/Badgers_Logo.png'
import YouTube from 'react-youtube'
import AddPhotoOrVideosNote from './AddPhotoOrVideosNote'
import Modal from '../../shared/components/UIElements/Modal'
var getYouTubeID = require('get-youtube-id')

const PlayerHistory = () => {
	//const { sendRequest, clearError } = useHttpClient()
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [loadedRosters, setLoadedRosters] = useState()
	const [firstName, setFirstName] = useState()
	const [lastName, setLastName] = useState()
	const [middleInitial, setMiddleInitial] = useState()
	const [number, setNumber] = useState()
	const [photo, setPhoto] = useState()
	const [listOfVideos, setListOfVideos] = useState()
	const [ids, setIds] = useState([])
	const [onlyBeenGoalie, setOnlyBeenGoalie] = useState()
	const [hasPlayedOutAndBeenGoalie, setHasPlayedOutAndBeenGoalie] = useState()
	const [neverPlayedGoalie, setNeverPlayedGoalie] = useState()
	const [processDone, setProcessDone] = useState(false)
	const [videoTitles, setVideoTitles] = useState([])
	const [videoCaptions, setVideoCaptions] = useState([])
	const [showInstructionsModal, setShowInstructionsModal] = useState(false)
	//
	const playerId = useParams().playerId
	//
	//
	//
	//Make a call to getPlayerHistoryByPlayerId in player-controller
	//UPDATE:  Were also going to see if there's any videos of this player
	//
	//
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/player/${playerId}/history`
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedRosters(responseData.listOfRosters)
				setFirstName(responseData.firstName)
				setLastName(responseData.lastName)
				setMiddleInitial(responseData.middleInitial)
				setNumber(responseData.number)
				setPhoto(responseData.photo)
				setListOfVideos(responseData.listOfVideos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [playerId, firstName, lastName, middleInitial])
	//
	//
	console.log('list of rosters: ' + JSON.stringify(loadedRosters))
	//
	//
	//
	let arrayOfTitles, arrayOfIds, arrayOfCaptions
	arrayOfTitles = []
	arrayOfIds = []
	arrayOfCaptions = []
	if (listOfVideos && !isLoading && ids.length === 0) {
		listOfVideos.forEach((video) => {
			arrayOfTitles.push(video.videoTitle)
			arrayOfIds.push(getYouTubeID(video.videoURL))
			arrayOfCaptions.push(video.videoCaption)
		})
	}
	//
	if (arrayOfTitles.length > 0) {
		setVideoTitles(arrayOfTitles)
	}
	if (arrayOfIds.length > 0) {
		setIds(arrayOfIds)
	}
	if (arrayOfCaptions.length > 0) {
		setVideoCaptions(arrayOfCaptions)
	}
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	//
	let wasGoalie, wasOut
	wasGoalie = 0
	wasOut = 0
	if (loadedRosters && !processDone) {
		setIsLoading(true)
		loadedRosters.forEach((roster) => {
			if (roster.isGoalie) {
				wasGoalie = wasGoalie + 1
			}
			if (!roster.isGoalie) {
				wasOut = wasOut + 1
			}
		})
		//
		console.log('wasGoalie: ' + wasGoalie)
		console.log('wasOut: ' + wasOut)
		//
		//
		if (wasGoalie > 0 && wasOut === 0) {
			console.log('this player is a life-long goalie - has never played out')
			setOnlyBeenGoalie(true)
		}
		if (wasGoalie > 0 && wasOut > 0) {
			console.log('this player has been both goalie AND played out')
			setHasPlayedOutAndBeenGoalie(true)
		}
		if (wasGoalie === 0 && wasOut > 0) {
			console.log('this player has NEVER played goalie')
			setNeverPlayedGoalie(true)
		}
		setProcessDone(true)
	}
	//
	//
	//
	const openInstructionModal = () => {
		setShowInstructionsModal(true)
	}
	//
	//
	const okHandler = () => {
		console.log('ok has been clicked')
		setShowInstructionsModal(null)
	}
	//
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<Modal
					show={showInstructionsModal}
					header='Add player photo or video(s)'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<p className='modalText'>
								Email your picture and any videos you may have to
								matt@shireystatsandstandings.com
							</p>
							<br></br>
							<p className='modalText'>
								Please include you or your childs name and team. If you're
								sending a video, please include a description.
							</p>
							<br></br>
							<button
								className='okButton instructionOKButton'
								inverse
								onClick={okHandler}
							>
								OKAY
							</button>
						</React.Fragment>
					}
				></Modal>
				<StatsAndStandingsHome />
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center' style={{ marginTop: '7rem' }}>
						<LoadingSpinner />
					</div>
				)}
				{!isLoading && loadedRosters && (
					<div className='Roster' style={{ marginTop: '7rem' }}>
						<div>
							<img src={badgersLogo} className='badgersLogo' />
						</div>
						{photo && (
							<div className='photoDiv'>
								<img
									src={`${process.env.REACT_APP_AWS_BUCKET}/${photo}`}
									//style={{ width: '9%' }}
									className='playerPhoto'
								/>
							</div>
						)}
						{!photo && (
							<button
								className='instructionButton'
								onClick={openInstructionModal}
							>
								<AddPhotoOrVideosNote />
							</button>
						)}
						<h1>
							#{number} - {firstName} {middleInitial} {lastName}
						</h1>
						<h3 className='h3Center'>Player History</h3>
						{onlyBeenGoalie && (
							<table id='roster'>
								<thead>
									<tr>
										<th>Team</th>
										<th>Year</th>
										<th>#</th>
										<th>WIns</th>
										<th>Losses</th>
										<th>Ties</th>
										<th>Shutouts</th>
										<th>GAA</th>
										{/* <th>Save %</th> */}
									</tr>
								</thead>
								<tbody>
									{loadedRosters.map((team, key) => {
										{
											return (
												<tr key={key}>
													<td>{team.teamName}</td>
													<td>{team.year}</td>
													<td>{team.number}</td>
													<td>{team.wins}</td>
													<td>{team.losses}</td>
													<td>{team.ties}</td>
													<td>{team.shutouts}</td>
													<td>
														{(
															team.goalsAgainst / team.goalieGamesPlayed
														).toFixed(3)}
													</td>
													{/* <td>{getSavePercentage(key)}</td> */}
												</tr>
											)
										}
									})}
								</tbody>
							</table>
						)}
						{neverPlayedGoalie && (
							<table id='roster'>
								<thead>
									<tr>
										<th>Team</th>
										<th>Year</th>
										<th>#</th>
										<th>G</th>
										<th>A</th>
										<th>Total</th>
										<th>PIM</th>
									</tr>
								</thead>
								<tbody>
									{loadedRosters.map((team, key) => {
										{
											return (
												<tr key={key}>
													<td>{team.teamName}</td>
													<td>{team.year}</td>
													<td>{team.number}</td>
													{team.showPlayerStats && <td>{team.goals}</td>}
													{team.showPlayerStats && <td>{team.assists}</td>}
													{team.showPlayerStats && (
														<td>{team.goals + team.assists}</td>
													)}
													{team.showPlayerStats && <td>{team.pim}</td>}
													{!team.showPlayerStats && <td> - </td>}
													{!team.showPlayerStats && <td> - </td>}
													{!team.showPlayerStats && <td> - </td>}
													{!team.showPlayerStats && <td> - </td>}
												</tr>
											)
										}
									})}
								</tbody>
							</table>
						)}
						{hasPlayedOutAndBeenGoalie && (
							<React.Fragment>
								<table id='roster'>
									<thead>
										<tr>
											<th>Team</th>
											<th>Year</th>
											<th>#</th>
											<th>G</th>
											<th>A</th>
											<th>Total</th>
											<th>PIM</th>
											<th>Wins</th>
											<th>Losses</th>
											<th>Ties</th>
											<th>Shutouts</th>
											<th>GAA</th>
										</tr>
									</thead>
									<tbody>
										{loadedRosters.map((team, key) => {
											return (
												<tr key={key}>
													<td>{team.teamName}</td>
													<td>{team.year}</td>
													<td>{team.number}</td>
													<td>{team.goals}</td>
													<td>{team.assists}</td>
													<td>{team.goals + team.assists}</td>
													<td>{team.pim}</td>
													<td>{team.wins}</td>
													<td>{team.losses}</td>
													<td>{team.ties}</td>
													<td>{team.shutouts}</td>
													<td>
														{(
															team.goalsAgainst / team.goalieGamesPlayed
														).toFixed(3)}
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</React.Fragment>
						)}
						{/* //
						//
						//
						//    Videos
						//
						//
						// */}
						{!isLoading && listOfVideos && (
							<div className='section pt-5 playerVideos'>
								<div className=''>
									<div className='row'>
										<div className='col text-center mb-0'>
											<h1 className='text-sh-dark display-2'>Check it out!</h1>
										</div>
									</div>
									<div className='row'>
										<div className='col-lg-3 col-sm-3'></div>
										<div className='col-lg-6 col-sm-6'>
											{listOfVideos.map((video, key) => {
												return (
													<div>
														<h1 style={{ color: 'red' }}>{video.videoTitle}</h1>

														<p
															className='caption'
															style={{
																textAlign: 'center',
																color: 'black',
															}}
														>
															{video.videoCaption}
														</p>
														{
															<YouTube
																style={{ paddingBottom: '3rem' }}
																videoId={ids[key]}
															/>
														}
													</div>
												)
											})}
										</div>
										<div className='col-lg-3 col-sm-3'></div>
									</div>
								</div>
							</div>
						)}
					</div>
				)}
				{!listOfVideos && (
					<div style={{ marginTop: '19rem' }}>
						<Footer />
					</div>
				)}
				{listOfVideos && (
					<div style={{ marginTop: '7rem' }}>
						<Footer />
					</div>
				)}
			</React.Fragment>
		</div>
	)
}

export default PlayerHistory
